/* PDFCommunity - Google Analytics loader (v65; was an inline <script> in
   every page's <head>, now its own file so it can be read and checked, and
   the Content-Security-Policy no longer needs a hash for inline code).
   Google Analytics is never loaded without consent: pdfcLoadGA() only runs
   after "Accept" (consent.js) or on a later page view within 12 months of
   that choice. Google Consent Mode starts with everything denied; only
   analytics_storage is granted when GA is loaded after consent, advertising
   storage stays denied. Nothing about the visitor's files is ever passed. */
(function(){
  'use strict';
  var GA_ID = 'G-Y3TTW60EEK';
  var CONSENT_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;
  window.gtag('consent', 'default', { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied' });
  // (v140) Google's own opt-out switch: while it is true, gtag sends nothing
  var GA_OFF = 'ga-disable-' + GA_ID;
  window.pdfcLoadGA = function(){
    window[GA_OFF] = false;
    window.gtag('consent', 'update', { analytics_storage: 'granted' });
    if(window.pdfcGALoaded) return; // accepted again after a decline on this page
    window.pdfcGALoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
  };
  // (v140) "Decline" stops Analytics on the spot, without reloading the page
  // (a reload would throw away a running or finished tool). Returns whether
  // it was running.
  window.pdfcStopGA = function(){
    if(!window.pdfcGALoaded) return false;
    window[GA_OFF] = true;
    window.gtag('consent', 'update', { analytics_storage: 'denied' });
    return true;
  };
  var consented = false;
  try{
    consented = localStorage.getItem('pdfc-consent') === 'granted' && Date.now() - Number(localStorage.getItem('pdfc-consent-at')) < CONSENT_MAX_AGE_MS;
  }catch(e){ consented = false; } // storage blocked: Google Analytics stays off
  if(consented) window.pdfcLoadGA();
})();
